import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    articleFirst:sessionStorage.getItem('articleFirst') ? JSON.parse(sessionStorage.getItem('articleFirst')) : {},
    articleLast:sessionStorage.getItem('articleLast') ? JSON.parse(sessionStorage.getItem('articleLast')) : {}
  },
  getters: {
  },
  mutations: {
    SET_ARTICLE_FIRST(state,data){
      sessionStorage.setItem('articleFirst',JSON.stringify(data))
      state.articleFirst = data
    },
    SET_ARTICLE_LAST(state,data){
      sessionStorage.setItem('articleLast',JSON.stringify(data))
      state.articleLast = data
    }
  },
  actions: {
  },
  modules: {
  }
})
